// extracted by mini-css-extract-plugin
export default {"root":"ArticleList_root__q8zDM","collection":"ArticleList_collection__7ReLl"};